var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"title":_vm.modalTitle,"classes":"modal-lg","onClose":_vm.onModalClose}},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12"},[_c('img',{attrs:{"src":_vm.imgUrl}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }